var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-entity',{staticClass:"c-level-map",attrs:{"geometry":_vm.geometryOptions,"material":"visible: false"}},[_vm._l((_vm.level.enemies),function(ref){
var id = ref.id;
var nodeId = ref.nodeId;
var type = ref.type;
return [_c('enemy',{key:'enemy-' + id,attrs:{"position":[
        _vm.level.nodes[nodeId].renderedX,
        _vm.level.nodes[nodeId].renderedY,
        _vm.level.nodes[nodeId].renderedZ
      ].join(' '),"type":type,"rotation":"90 0 0"}})]}),_vm._l((_vm.uncollectedItems),function(ref){
      var id = ref.id;
      var nodeId = ref.nodeId;
      var type = ref.type;
return [_c('item',{key:'item-' + id,attrs:{"position":[
        _vm.level.nodes[nodeId].renderedX,
        _vm.level.nodes[nodeId].renderedY,
        _vm.level.nodes[nodeId].renderedZ
      ].join(' '),"type":type,"rotation":"90 0 0"}})]}),_vm._l((_vm.level.nodes),function(node){return [_c('node',{key:'node-' + node.id,attrs:{"position":[
        node.renderedX,
        node.renderedY,
        node.renderedZ
      ].join(' '),"node":node}})]}),_vm._l((_vm.level.paths),function(ref){
      var id = ref.id;
      var sourceNodeId = ref.sourceNodeId;
      var targetNodeId = ref.targetNodeId;
return [_c('node-path',{key:'path-' + id,attrs:{"source-node":_vm.level.nodes[sourceNodeId],"target-node":_vm.level.nodes[targetNodeId]}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }